import { createWebHistory, createRouter } from "vue-router";
import routes from './routes';
// import appConfig from "../../app.config";
import { getBaseTitle } from "@/helpers/document-utils";

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // If route is public, allow access
  if (to.meta.public) {
    return next();
  }

  // Check for token in localStorage or sessionStorage
  const authLocal = localStorage.getItem('token');
  const authSession = sessionStorage.getItem('token');
  const isAuthorized = Boolean(authLocal || authSession);

  // If user is authorized and trying to access auth pages, redirect to home
    if (isAuthorized && (to.path === '/login' || to.path === '/register' || to.path === '/account/verification-code' || to.path === '/account/forgot-password' || to.path === '/account/reset-password')) {
      window.location.href = '/';
    return;
  }

  // If user is not authorized and trying to access auth pages, allow access
  if (!isAuthorized && (to.path === '/login' || to.path === '/register' || to.path === '/account/verification-code' || to.path === '/account/forgot-password' || to.path === '/account/reset-password')) {
    return next();
  }

  // If user is not authorized and trying to access protected route, redirect to login
  if (!isAuthorized) {
    // Save intended path for redirect after login
    localStorage.setItem('redirectPath', to.fullPath);
    return next('/login');
  }

  // User is authorized, allow access
  next();
});

// Set document title dynamically
router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    const baseTitle = getBaseTitle();
    document.title = to.meta.title + ' | ' + baseTitle;
  }
});

export default router;
